export { default } from "./CartCarousel";
